import firebase from "firebase";
import "firebase/firestore";

try {
  const config = {
    apiKey: "AIzaSyBV1LWkIcTu1MMaKcW5s3aZg4wc22FdAWM",
    authDomain: "dsa-recruitment.firebaseapp.com",
    databaseURL: "https://dsa-recruitment.firebaseio.com",
    projectId: "dsa-recruitment",
    storageBucket: "dsa-recruitment.appspot.com",
    messagingSenderId: "524097532225"
  };
  firebase.initializeApp(config);
} catch (e) {}

export const storage = firebase.storage();
export const auth = firebase.auth();
export const db = firebase.firestore();



// WEBPACK FOOTER //
// ./src/config.js